// WebSite.js
import React, { useState } from "react";
import LanguageModal from "./LanguageModal";

const WebSite = () => {
  const [showModal, setShowModal] = useState(false);

  const links = {
    en: "https://www.hotelcondesa.com/en/",
    es: "https://www.hotelcondesa.com/",
    // ru: "https://www.hotelcondesa.com/ru/",
    de: "https://www.hotelcondesa.com/de/",
  };

  return (
    <>
      {/* biome-ignore lint/a11y/useButtonType: <explanation> */}
      <button
        className="button-styles hover-text"
        onClick={() => setShowModal(true)}
      >
        <span className="tooltip-text fade">
          Web Site
        </span>
        <i className="bi bi-globe-americas" />
      </button>
      {showModal && (
        <LanguageModal
          title="Web Site"
          icon="bi bi-globe-americas"
          links={links}
          onClose={() => setShowModal(false)}
        />
      )}
    </>
  );
};

export default WebSite;
